var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "free-trial-vue1" } }, [
    _vm.isPCEnd
      ? _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "container-box" }, [
            _c(
              "div",
              {
                staticClass: "leftBox",
                style: {
                  top:
                    _vm.validStep === 1
                      ? "50px"
                      : _vm.lang === "en"
                      ? "80px"
                      : "0"
                }
              },
              [
                _c("div", [
                  _c("p", { staticClass: "left-title" }, [
                    _vm._v(_vm._s(_vm.$t("freedeploy")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "platform" }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-item on-cloud-tab",
                        class: { active: !_vm.deployonPrem },
                        on: {
                          click: function($event) {
                            return _vm.changeTabBar("on-cloud")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("freedeployoncloud")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "tab-item on-premises",
                        class: { active: _vm.deployonPrem },
                        on: {
                          click: function($event) {
                            return _vm.changeTabBar("on-premises")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("freedeployonprem")) +
                            "\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.deployonPrem,
                          expression: "!deployonPrem"
                        }
                      ],
                      staticClass: "on-cloud-section",
                      staticStyle: { width: "89%" }
                    },
                    [
                      _c("div", { staticClass: "on-cloud-desc" }, [
                        _vm._v(_vm._s(_vm.$t("freedeployonclouddesc")))
                      ]),
                      _vm._v(" "),
                      !_vm.showStepTwoForm &&
                      _vm.validStep === 1 &&
                      !_vm.isLogin
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "field-container" },
                              [
                                _c(
                                  "el-form",
                                  {
                                    ref: "emailForm",
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      model: _vm.dataEmail,
                                      rules: _vm.rulesEmail,
                                      "status-icon": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "email" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "text",
                                            size: "large",
                                            placeholder: _vm.$t("yourWorkEmail")
                                          },
                                          model: {
                                            value: _vm.dataEmail.email,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dataEmail,
                                                "email",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "dataEmail.email"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-bottom": "12px",
                                      "margin-top": "20px"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      staticClass: "button red_btn hvr-round",
                                      staticStyle: { "margin-top": "5px" },
                                      attrs: { type: "submit" },
                                      domProps: { value: _vm.$t("deployNow") },
                                      on: { click: _vm.checkStep1Email }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "click-here" }, [
                              _vm._v(_vm._s(_vm.$t("haveAccount1"))),
                              _c(
                                "a",
                                {
                                  staticClass: "change-page",
                                  attrs: { href: _vm.loginUrl }
                                },
                                [_vm._v(_vm._s(_vm.$t("haveAccount2")))]
                              ),
                              _vm._v(_vm._s(_vm.$t("haveAccount3")))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStepTwoForm && !_vm.isLogin
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "ruleFormOnCloud",
                                  staticClass: "trial-form",
                                  attrs: {
                                    model: _vm.dataOnCloud,
                                    rules: _vm.rulesOnCloud,
                                    "status-icon": ""
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "48%" },
                                          attrs: { prop: "lastName" }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              type: "text",
                                              size: "large",
                                              placeholder: _vm.$t("fistName")
                                            },
                                            model: {
                                              value: _vm.dataOnCloud.lastName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataOnCloud,
                                                  "lastName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "dataOnCloud.lastName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "48%" },
                                          attrs: { prop: "firstName" }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              type: "text",
                                              size: "large",
                                              placeholder: _vm.$t("lastName")
                                            },
                                            model: {
                                              value: _vm.dataOnCloud.firstName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataOnCloud,
                                                  "firstName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "dataOnCloud.firstName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "email" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "text",
                                          size: "large",
                                          disabled: true,
                                          placeholder: _vm.$t("yourWorkEmail")
                                        },
                                        model: {
                                          value: _vm.dataOnCloud.email,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dataOnCloud,
                                              "email",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "dataOnCloud.email"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "flex-start",
                                        "margin-bottom": "24px"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "country-drop" },
                                        [
                                          _c("vue-country-code", {
                                            attrs: {
                                              defaultCountry: _vm.countryCode,
                                              preferredCountries:
                                                _vm.defaultCountryArr
                                            },
                                            on: {
                                              onSelect: _vm.onSelectOnCloud
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "87%" },
                                          attrs: { prop: "intlTel" }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              type: "text",
                                              size: "large",
                                              placeholder: _vm.$t("phoneNumber")
                                            },
                                            model: {
                                              value: _vm.dataOnCloud.intlTel,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataOnCloud,
                                                  "intlTel",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "dataOnCloud.intlTel"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "checkbox-con",
                                  staticStyle: {
                                    display: "flex",
                                    margin: "30px 0"
                                  }
                                },
                                [
                                  this.lang === "zh-cn"
                                    ? _c("el-checkbox", {
                                        on: { change: _vm.handleCheckChange },
                                        model: {
                                          value: _vm.isCheckedOnCloud,
                                          callback: function($$v) {
                                            _vm.isCheckedOnCloud = $$v
                                          },
                                          expression: "isCheckedOnCloud"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      style: {
                                        "border-bottom": _vm.isAgreementCloud
                                          ? "none"
                                          : "1px solid #e03b3b",
                                        "font-size": "14px",
                                        "margin-left": "5px"
                                      }
                                    },
                                    [
                                      _vm._v(_vm._s(_vm.$t("clickSubmit"))),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "change-page",
                                          attrs: {
                                            href: _vm.$t("termsOfServiceLink"),
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("clickSubmit1")))]
                                      ),
                                      _vm._v(_vm._s(_vm.$t("clickSubmit2"))),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "change-page",
                                          attrs: {
                                            href: _vm.$t("privacyPolicyLink"),
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("clickSubmit3")))]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticStyle: { width: "100%" } }, [
                                _c("input", {
                                  staticClass: "button red_btn hvr-round",
                                  staticStyle: { "margin-top": "0px" },
                                  attrs: {
                                    type: "submit",
                                    id: "submit_quick_trial_cloud"
                                  },
                                  domProps: { value: _vm.$t("createAcount") },
                                  on: { click: _vm.validateForm }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      "margin-top": "20px",
                                      "font-size": "14px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("haveAccount1")) + " "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "change-page",
                                        attrs: { href: _vm.loginUrl }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("haveAccount2")))]
                                    ),
                                    _vm._v(_vm._s(_vm.$t("haveAccount3")))
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.validStep === 3 && _vm.isLogin
                        ? _c(
                            "div",
                            {
                              staticClass: "license-con",
                              staticStyle: { "margin-top": "20px" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "license-text padding-none" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.deployObj.msg) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "button red_btn hvr-round",
                                  staticStyle: {
                                    "text-transform": "none",
                                    "margin-top": "20px",
                                    width: "100%",
                                    "text-align": "center",
                                    display: "block"
                                  },
                                  attrs: {
                                    href: _vm.routerToDeploy,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.deployObj.btn_text))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "contact-us" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("contactUs")))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "mailto:support@Kyligence.io"
                                    }
                                  },
                                  [_vm._v("support@kyligence.io")]
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.deployonPrem,
                          expression: "deployonPrem"
                        }
                      ],
                      staticClass: "on-prem-section",
                      staticStyle: { width: "89%" }
                    },
                    [
                      _c("div", { staticClass: "on-prem-desc" }, [
                        _vm._v(_vm._s(_vm.$t("freedeployonpremdesc")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          ref: "ruleOnPremForm",
                          staticClass: "OnPremForm",
                          attrs: {
                            model: _vm.onPremData,
                            rules: _vm.rulesOnPrem,
                            "status-icon": ""
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "48%" },
                                  attrs: { prop: "lastName" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      size: "large",
                                      placeholder: _vm.$t("fistName")
                                    },
                                    model: {
                                      value: _vm.onPremData.lastName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.onPremData,
                                          "lastName",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "onPremData.lastName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "48%" },
                                  attrs: { prop: "firstName" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      size: "large",
                                      placeholder: _vm.$t("lastName")
                                    },
                                    model: {
                                      value: _vm.onPremData.firstName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.onPremData,
                                          "firstName",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "onPremData.firstName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "company" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "text",
                                  size: "large",
                                  placeholder: _vm.$t("yourCompany")
                                },
                                model: {
                                  value: _vm.onPremData.company,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.onPremData,
                                      "company",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "onPremData.company"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "email" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "text",
                                  size: "large",
                                  placeholder: _vm.$t("yourWorkEmail")
                                },
                                model: {
                                  value: _vm.onPremData.email,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.onPremData,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "onPremData.email"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-start"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "country-drop" },
                                [
                                  _c("vue-country-code", {
                                    attrs: {
                                      defaultCountry: _vm.countryCode,
                                      preferredCountries: _vm.defaultCountryArr
                                    },
                                    on: { onSelect: _vm.onSelectOnPrem }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "88%" },
                                  attrs: { prop: "intlTel" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      size: "large",
                                      placeholder: _vm.$t("phoneNumber")
                                    },
                                    model: {
                                      value: _vm.onPremData.intlTel,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.onPremData,
                                          "intlTel",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "onPremData.intlTel"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "checkbox-con",
                          staticStyle: { display: "flex", margin: "30px 0" }
                        },
                        [
                          this.lang === "zh-cn"
                            ? _c("el-checkbox", {
                                on: { change: _vm.handleCheckChangeOnPrem },
                                model: {
                                  value: _vm.isCheckedOnPrem,
                                  callback: function($$v) {
                                    _vm.isCheckedOnPrem = $$v
                                  },
                                  expression: "isCheckedOnPrem"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              style: {
                                "border-bottom": _vm.isAgreementOnPrem
                                  ? "none"
                                  : "1px solid #e03b3b",
                                "font-size": "14px",
                                "margin-left": "5px"
                              }
                            },
                            [
                              _vm._v(_vm._s(_vm.$t("clickSubmit"))),
                              _c(
                                "a",
                                {
                                  staticClass: "change-page",
                                  attrs: {
                                    href: _vm.$t("termsOfServiceLink"),
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("clickSubmit1")))]
                              ),
                              _vm._v(_vm._s(_vm.$t("clickSubmit2"))),
                              _c(
                                "a",
                                {
                                  staticClass: "change-page",
                                  attrs: {
                                    href: _vm.$t("privacyPolicyLink"),
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("clickSubmit3")))]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: { width: "100%", "margin-top": "30px" }
                        },
                        [
                          _c("input", {
                            staticClass: "button red_btn hvr-round",
                            staticStyle: { "margin-top": "0px" },
                            attrs: {
                              type: "submit",
                              id: "submit_quick_trial_cloud"
                            },
                            domProps: { value: _vm.$t("applyForTrial") },
                            on: { click: _vm.validateFormOnPrem }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "margin-top": "20px",
                                "font-size": "14px"
                              }
                            },
                            [
                              _vm._v(_vm._s(_vm.$t("haveAccount1")) + " "),
                              _c(
                                "a",
                                {
                                  staticClass: "change-page",
                                  attrs: { href: _vm.loginUrl }
                                },
                                [_vm._v(_vm._s(_vm.$t("haveAccount2")))]
                              ),
                              _vm._v(_vm._s(_vm.$t("haveAccount3")))
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "container-box",
              style: {
                background:
                  _vm.validStep === 1 || _vm.validStep === 3
                    ? "rgba(240, 241, 244, 0.5)"
                    : "#fff",
                height: "906px",
                width: "45%",
                "margin-left": "54px"
              }
            },
            [
              _c(
                "div",
                {
                  class:
                    _vm.validStep === 1 || _vm.validStep === 3
                      ? "validate-con-deploy"
                      : "validate-con width-validate-con",
                  style: {
                    top:
                      _vm.validStep === 1 || _vm.validStep === 3 ? "45%" : "",
                    transform:
                      _vm.validStep === 1 || _vm.validStep === 3
                        ? "translateY(-50%)"
                        : "",
                    "margin-top": _vm.lang === "en" ? "100px" : "16px"
                  }
                },
                [
                  _vm.validStep === 1 || _vm.validStep === 3
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.deployonPrem,
                                expression: "!deployonPrem"
                              }
                            ],
                            staticClass: "on-cloud-right"
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  _vm.lang === "en"
                                    ? "https://siteprod-s3-cdn.kyligence.io/2022/03/1648191635-on_cloud_logo_en.png"
                                    : "https://siteprod-s3-cdn.kyligence.io/2022/03/1648095779-on_cloud_logo_cn.png",
                                width: "80%"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "ftS20",
                                style: {
                                  "margin-top": "44px!important",
                                  "margin-bottom": "58px!important",
                                  "padding-right":
                                    _vm.lang === "en" ? "12px" : "inherit",
                                  "line-height":
                                    _vm.lang === "en" ? "32px" : "inherit"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("deployTitle2")))]
                            ),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", { staticClass: "test-drive-word" }, [
                                _c("div", [
                                  _c("p", { staticClass: "li-top" }, [
                                    _vm._v(_vm._s(_vm.$t("deployTitle21")))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "li-bottom" }, [
                                    _vm._v(_vm._s(_vm.$t("deployTitle22")))
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "li",
                                { staticClass: "test-drive-word top-icon" },
                                [
                                  _c("div", [
                                    _c("p", { staticClass: "li-top" }, [
                                      _vm._v(_vm._s(_vm.$t("deployTitle23")))
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "li-bottom" }, [
                                      _vm._v(_vm._s(_vm.$t("deployTitle24")))
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                { staticClass: "test-drive-word third-icon" },
                                [
                                  _c("div", [
                                    _c("p", { staticClass: "li-top" }, [
                                      _vm._v(_vm._s(_vm.$t("deployTitle25")))
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "li-bottom" }, [
                                      _vm._v(_vm._s(_vm.$t("deployTitle26")))
                                    ])
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "choose-deploy",
                                style: {
                                  "margin-top": "56px!important",
                                  "padding-right":
                                    _vm.lang === "en" ? "12px" : "inherit",
                                  "line-height":
                                    _vm.lang === "en" ? "32px" : "inherit"
                                }
                              },
                              [
                                _vm._v(_vm._s(_vm.$t("deployDrive1"))),
                                _c(
                                  "a",
                                  {
                                    staticClass: "change-page",
                                    attrs: { href: "/zh/try" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("deployDrive2")))]
                                ),
                                _vm._v(_vm._s(_vm.$t("deployDrive3")))
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.deployonPrem,
                                expression: "deployonPrem"
                              }
                            ],
                            staticClass: "on-premises-right"
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  "https://siteprod-s3-cdn.kyligence.io/2022/03/1647416030-on_premises_illustrate.png",
                                width: "80%"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "ftS20",
                                style: {
                                  "margin-top": "44px!important",
                                  "margin-bottom": "58px!important",
                                  "padding-right":
                                    _vm.lang === "en" ? "12px" : "inherit",
                                  "line-height":
                                    _vm.lang === "en" ? "32px" : "inherit"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("deployTitle2c")))]
                            ),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", { staticClass: "test-drive-word" }, [
                                _c("div", [
                                  _c("p", { staticClass: "li-top" }, [
                                    _vm._v(_vm._s(_vm.$t("deployTitle21c")))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "li-bottom" }, [
                                    _vm._v(_vm._s(_vm.$t("deployTitle22c")))
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "li",
                                { staticClass: "test-drive-word top-icon" },
                                [
                                  _c("div", [
                                    _c("p", { staticClass: "li-top" }, [
                                      _vm._v(_vm._s(_vm.$t("deployTitle23c")))
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "li-bottom" }, [
                                      _vm._v(_vm._s(_vm.$t("deployTitle24c")))
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                { staticClass: "test-drive-word third-icon" },
                                [
                                  _c("div", [
                                    _c("p", { staticClass: "li-top" }, [
                                      _vm._v(_vm._s(_vm.$t("deployTitle25c")))
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "li-bottom" }, [
                                      _vm._v(_vm._s(_vm.$t("deployTitle26c")))
                                    ])
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "choose-deploy",
                                style: {
                                  "margin-top": "56px!important",
                                  "padding-right":
                                    _vm.lang === "en" ? "12px" : "inherit",
                                  "line-height":
                                    _vm.lang === "en" ? "32px" : "inherit"
                                }
                              },
                              [
                                _vm._v(_vm._s(_vm.$t("deployDrive1"))),
                                _c(
                                  "a",
                                  {
                                    staticClass: "change-page",
                                    attrs: { href: "/zh/try" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("deployDrive2")))]
                                ),
                                _vm._v(_vm._s(_vm.$t("deployDrive3")))
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isPCEnd
      ? _c("div", { staticClass: "container-phone" }, [
          _c("div", { staticClass: "moble-bg" }, [
            _c("p", { staticClass: "not-support" }, [
              _vm._v(_vm._s(_vm.$t("notSupportPhone")))
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddaabc1c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddaabc1c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./App/components/renamePage/renamePage.vue
// module id = 769
// module chunks = 1